import React from "react";
import { MdDashboard, MdEdit, MdDelete, MdPerson } from "react-icons/md";

// Campus List Component
function CampusList({
  campuses,
  onEdit,
  onDelete,
  onViewStaff,
  // onViewAnalytics,
  onSelectCampus,
  analyticsOnly = false,
  showListHeader = true,
}) {
  return (
    <div className="campus-management">
      {!analyticsOnly && showListHeader && (
        <div className="section-header">
          <h2 className="section-title">
            <span className="accent-line" /> Campuses
          </h2>
        </div>
      )}
      <div
        className={`campus-grid ${analyticsOnly ? "viewer-campus-grid" : ""}`}
      >
        {campuses.map((campus) => (
          <div
            className={`campus-card clickable ${
              analyticsOnly ? "viewer-campus-card" : ""
            } ${analyticsOnly && !campus.hasDashboard ? "dashboard-missing" : ""}`}
            key={campus.id}
            onClick={() => onSelectCampus?.(campus)}
          >
            <div
              className={`campus-card-header ${
                analyticsOnly ? "viewer-campus-card-header" : ""
              }`}
            >
              <div className="campus-icon">
                <MdDashboard />
              </div>
              {analyticsOnly ? (
                <div className="viewer-campus-title">
                  <h3>{campus.name}</h3>
                  <span
                    className={`viewer-dashboard-status ${
                      campus.hasDashboard ? "ready" : "missing"
                    }`}
                  >
                    {campus.hasDashboard ? "Dashboard Ready" : "Not Configured"}
                  </span>
                </div>
              ) : (
                <h3>{campus.name}</h3>
              )}
            </div>
            <div className="campus-card-body">
              <p>
                <strong>Location:</strong> {campus.location || "N/A"}
              </p>
              <p>
                <strong>Principal:</strong> {campus.principal || "Not Assigned"}
              </p>
              <p className="campus-date">
                ID: {campus.id} • Created:{" "}
                {campus.created_at
                  ? new Date(campus.created_at).toLocaleDateString()
                  : new Date().toLocaleDateString()}
              </p>
            </div>
            <div
              className={`campus-card-footer ${
                analyticsOnly ? "viewer-campus-card-footer" : ""
              }`}
              onClick={(e) => e.stopPropagation()}
            >
              {/* <button
                className="btn-text-analytics"
                onClick={() => onViewAnalytics(campus)}
                disabled={analyticsOnly && !campus.hasDashboard}
              >
                Analytics
              </button> */}
              {!analyticsOnly && (
                <>
                  {onViewStaff && (
                    <button 
                      className="btn-text-staff" 
                      onClick={() => onViewStaff(campus)}
                      title="Manage Staff"
                    >
                      <MdPerson /> Staff
                    </button>
                  )}
                  <button className="btn-text" onClick={() => onEdit(campus)}>
                    <MdEdit /> Edit
                  </button>
                  <button
                    className="btn-text-danger"
                    onClick={() => onDelete(campus.id)}
                  >
                    <MdDelete /> Delete
                  </button>
                </>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default CampusList;